module.exports = __webpack_public_path__ + "media/images/amenities_icons/community_drinks-1fdc541e326bc79affda1f0663dd9cd4.svg";